export function StatisticsContainer ({ pxSmall=false, children }) {
    const paddingX = pxSmall ? { paddingLeft: 10, paddingRight: 10 } : {};

    return(
        <div className="statistics-container" style={paddingX}>
            { children }
        </div>
    )
}